import React, {useState} from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content';
import "./Contact.css";
import Footer from './Footer';
import Header from './Header';

const MySwal = withReactContent(Swal)


const Contact=(props)=>{
    const [enteredName,setEnteredName]=useState('');
    const [enteredEmail,setEnteredEmail]=useState('');
    const [enteredPhone,setEnteredPhone]=useState('');
    const [enteredQuery,setEnteredQuery]=useState('');

    const nameChangeHandler=(event)=>{
        setEnteredName(event.target.value)
    };
    const emailChangeHandler=(event)=>{
        setEnteredEmail(event.target.value)
    };
    const phoneChangeHandler=(event)=>{
        setEnteredPhone(event.target.value)
    };
    const queryChangeHandler=(event)=>{
        setEnteredQuery(event.target.value)
    };

    const submitHandler= async (event)=>{
        event.preventDefault();
        const formData={
            name:enteredName,
            email:enteredEmail,
            phone:enteredPhone,
            query:enteredQuery
        }

    console.log(formData)
    // const response =await fetch('/student',{
    //     method:'POST',
    //     body:JSON.stringify(formData),
    //     headers:{
    //         'Content-Type':'application/json',
    //     }
    // });
   const data='';//await response.json();
   if(data.length!==0){

            MySwal.fire({
                title: <p>Thanks for your trust , we will get back to you shortely</p>,
                icon:'success',
                // didOpen: () => {
                // // `MySwal` is a subclass of `Swal` with all the same instance & static methods
                // //MySwal.showLoading()
                // },
            }).then(() => {
                return //MySwal.fire(<p>Shorthand works too</p>)
            })
   }
   console.log(data);
   setEnteredName('');
   setEnteredEmail('');
   setEnteredPhone('');

    };
  return (
    <>
    <Header />


   

    <Form onSubmit={submitHandler} className="container form">
        
    <div className='contact-form'>
    <h2> Contact Form</h2>
      <Form.Group className="mb-2 name" controlId="formBasicName">
        <Form.Label>Name</Form.Label>
        <Form.Control type="text" value={enteredName} onChange={nameChangeHandler} placeholder="Enter your name" />
      </Form.Group>
      <Form.Group className="mb-3" controlId="formBasicEmail">
        <Form.Label>Email address</Form.Label>
        <Form.Control type="email" value={enteredEmail} onChange={emailChangeHandler} placeholder="Enter email" />
        {/* <Form.Text className="text-muted">
          We'll never share your email with anyone else.
        </Form.Text> */}
      </Form.Group>
      <Form.Group className="mb-3" controlId="formBasicPhone">
        <Form.Label>Phone</Form.Label>
        <Form.Control type="number" value={enteredPhone} onChange={phoneChangeHandler} placeholder="Enter phone" />
      </Form.Group>
      <Form.Group className="mb-3" controlId="formBasicQuery">
        <Form.Label>Query</Form.Label>
        <Form.Control as="textarea" value={enteredQuery} onChange={queryChangeHandler} rows={4} />
      </Form.Group>
      
      <Button variant="primary" type="submit">
        Submit
      </Button>
      </div>
    </Form>




    <div className="container-fluid">
 
 <div className="row">
     <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-justify"><p className=""> 
     <b>Corporate Office </b> : HOUSE NO. 45, SECOND FLOOR, UDAY PARK COLONY, PALLAVPURAM PHASE-2, MODIPURAM MEERUT Meerut, Uttar Pradesh.250110 </p>
    <p><b>Concerned Persons:</b> 
Mr.                            Devendra Prasad Yadav
</p>
<p> <b>Phone :</b>9877764780, 8960958236</p>
<p> <b>Email :</b>info@levinaindia.com ,levina.india,projects@gmail.com</p>
</div>
  
 </div>
</div>


    <Footer />
    </>
  );
}

export default Contact;